export const CoinbaseIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="14" fill="#0052FF" />
    <path
      d="M14.0055 18.682C11.419 18.682 9.32403 16.5871 9.32403 14.0006C9.32403 11.4141 11.419 9.31914 14.0055 9.31914C16.3228 9.31914 18.2461 11.0084 18.6167 13.2204H23.3333C22.9354 8.41406 18.9132 4.6377 14.0055 4.6377C8.83638 4.6377 4.64258 8.83149 4.64258 14.0006C4.64258 19.1697 8.83638 23.3635 14.0055 23.3635C18.9132 23.3635 22.9354 19.5871 23.3333 14.7808H18.6128C18.2422 16.9928 16.3228 18.682 14.0055 18.682Z"
      fill="white"
    />
  </svg>
)
